import styled from "styled-components";
import { BurgerContainerProps } from "../../interfaces/BurgerMenuInterface";

export const BurgerContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "showMenu",
})<BurgerContainerProps>`
  display: none;
  background-color: #001a47;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  padding-top: 3.25rem;
  overflow-y: scroll;
  z-index: 10;
  transition: all 0.5s;
  height: 100%;
  width: 100%;
  left: ${({ showMenu }) => (showMenu ? "0" : "-103%")};

  @media (max-width: 1024px) {
    display: block;
  }
`;

export const ToggleContainer = styled.div`
  position: relative;
  width: 100%;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  margin-top: 5rem;
  font-size: 1rem;
`;

export const LangAndBtn = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1.5rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;

  .mob__lang__menu {
    box-shadow: none;
    font-size: 1.1rem;
    font-weight: 700;
    margin-bottom: 1.5rem;
    border-radius: 4px;
  }

  .header__buttons {
    background-color: white;
    color: black;
    margin-top: 1.5rem;
    width: 14rem;
    margin: auto;
    border: 1px solid white;
    border-radius: 4px;
    font-size: 1.1rem;
    line-height: 1.063rem;
    padding: 0.563rem 1.875rem 0.563rem 1.875rem;
    font-weight: 700;
    text-align: center;
  }
`;
